import React from 'react';
import PropTypes from 'prop-types';

// Subcomponent: Form Input Field
export const FormInputField = ({ label, name, value, onChange, error, placeholder }) => (
    <div className="row">
        <div className="col-3 formLabel fw-3">{label}</div>
        <div className="col-9">
            <input
                onChange={onChange}
                value={value}
                className="form-control"
                name={name}
                type="text"
                placeholder={placeholder}
            />
            <p className="error dialogError">{error}</p>
        </div>
    </div>
);

FormInputField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    placeholder: PropTypes.string,
};

FormInputField.defaultProps = {
    error: '',
    placeholder: '',
};

// Subcomponent: Affiliate Form Content
export const AffiliateFormContent = ({ formData, errors, onFieldChange }) => (
    <FormInputField
        label="Email"
        name="email"
        value={formData.email}
        onChange={onFieldChange}
        error={errors.email}
        placeholder="Enter email address"
    />
);

AffiliateFormContent.propTypes = {
    formData: PropTypes.shape({
        email: PropTypes.string.isRequired,
    }).isRequired,
    errors: PropTypes.shape({
        email: PropTypes.string,
    }).isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

// Subcomponent: Popup Footer
export const PopupFooter = ({ onSubmit, submitButtonText, submitButtonClass, isLoading }) => (
    <div className="row">
        <div className="col-3"></div>
        <div className="col-9 d-flex justify-content-end">
            <button
                className={`btn ${submitButtonClass}`}
                id="addAffiliateBtnPopup"
                onClick={onSubmit}
                disabled={isLoading}
            >
                {isLoading ? 'Submitting...' : submitButtonText}
            </button>
        </div>
    </div>
);

PopupFooter.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    submitButtonText: PropTypes.string,
    submitButtonClass: PropTypes.string,
    isLoading: PropTypes.bool,
};

PopupFooter.defaultProps = {
    submitButtonText: 'Add',
    submitButtonClass: 'cus-seconday-bg-btn marginLeft5',
    isLoading: false,
};
